webpackJsonp([2841517874621],{

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullTimeStaffPage = function FullTimeStaffPage() {
	    return _react2.default.createElement(
	        "div",
	        { className: "staticPage" },
	        _react2.default.createElement(
	            "h1",
	            null,
	            "YCFC Staff"
	        ),
	        _react2.default.createElement(
	            "h3",
	            null,
	            "Robbie Harris, Executive Director"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Robbie has served on full time staff since 1995. He graduated from the University of North Carolina at Greensboro with a B.S. in Business Management. Robbie received his MBA from Campbell University. Christian camping has been very influential in his life as he attended Camp Willow Run as a camper from grades 3-12 and served on summer staff. His desire is \u201Cto provide a camping environment in which campers learn more about a relationship with Jesus Christ while having fun!\u201D Robbie and his wife, Kristie (also a former CWR summer staffer) are the proud parents of Jackson, Eli, and Thad."
	        )
	    );
	};
	
	exports.default = FullTimeStaffPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ycfc-staff-js-a51c6c910205056caf75.js